var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"birthday-item text-center"},[_c('img',{staticClass:"img-birth",attrs:{"src":_vm.image,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"text-bold"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9ac4ac4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Birthday/BirthdayItem.vue
// module id = null
// module chunks = 